
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/fault-reporting",
      function () {
        return require("private-next-pages/support/fault-reporting.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/fault-reporting"])
      });
    }
  